module.exports = __webpack_public_path__ + "img/new_22_2.1771480d.jpg";